import { jsx as _jsx } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const Close = (props) => {
    const iconProps = useIconProps(props);
    const computedStrokeWidth = useStrokeWidth(iconProps.width);
    return (_jsx("svg", Object.assign({}, iconProps, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M1.60001 30.4L30.4 1.60001M1.60001 1.60001L30.4 30.4", stroke: "currentColor", strokeWidth: props.strokeWidth ? props.strokeWidth : computedStrokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
export default Close;
